import { Component } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-loader-overlay',
    templateUrl: './molecule-loader-overlay.component.html',
    standalone: false,
})
export class MoleculeLoaderOverlayComponent {}
